// extracted by mini-css-extract-plugin
export default {"validation-message-notice":"address-confirmation_validation-message-notice__fbFm2"};